// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnlockOutlinedSvg from "@ant-design/icons-svg/es/asn/UnlockOutlined";
import AntdIcon from '../components/AntdIcon';

var UnlockOutlined = function UnlockOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnlockOutlinedSvg
  }));
};

UnlockOutlined.displayName = 'UnlockOutlined';
export default React.forwardRef(UnlockOutlined);